module.exports = __webpack_public_path__ + "static/media/xls.ea1219ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryUploadInfo/images/xls.svg
// module id = 651
// module chunks = 0